import axios from "axios";
import store from "./components/store/store";
import { loginFailure } from "./components/store/auth/authSlice";

let isLoggingOut = false;

function forceLogout() {
  if (isLoggingOut) return;
  // HashRouter: real path is in window.location.hash, not pathname
  if (window.location.hash.includes("/cms/login")) return;
  isLoggingOut = true;
  // Save the current hash route so Login can redirect back to it after re-auth
  const currentPath = window.location.hash.replace(/^#/, "").trim();
  if (currentPath && currentPath !== "/" && !currentPath.includes("/cms/login")) {
    sessionStorage.setItem("postLoginRedirect", currentPath);
  }
  localStorage.clear();
  store.dispatch(loginFailure());
  window.location.replace("/#/cms/login");
}

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => {
      // Some endpoints return HTTP 200 with { status: 401 } in the body
      if (response?.data?.status === 401) {
        forceLogout();
      }
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        forceLogout();
      }
      return Promise.reject(error);
    },
  );
}
